import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const PrivateRoute = ({
  element,
  allowedRoles,
  requireManagedCourse = false,
}) => {
  const { authState } = useAuthContext();
  const params = useParams();

  if (!authState?.id) {
    alert("Access denied: Please log in to access this page.");
    return <Navigate to="/" replace />;
  }

  // Ensure coursesManaged is always an array
  const { role, coursesManaged = [] } = authState;

  if (allowedRoles && allowedRoles.length > 0) {
    const roleAllowed = allowedRoles.includes(role);
    if (!roleAllowed) {
      alert("Access denied: You do not have permission to access this page.");
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (requireManagedCourse) {
    const courseId = params.courseId ?? null;
    const isSuperAdmin = role === "admin";
    const hasAccess = isSuperAdmin || (courseId && coursesManaged.includes(courseId));

    if (!hasAccess) {
      alert("Access denied: You do not have permission to access this page.");
      return <Navigate to="/dashboard" replace />;
    }
  }

  return element;
};
export default PrivateRoute;
